import { render, staticRenderFns } from "./OrganisationInformation.vue?vue&type=template&id=ecfc665e&"
import script from "./OrganisationInformation.vue?vue&type=script&lang=js&"
export * from "./OrganisationInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports